const smartMoneyTransactions = [
  {
    ticker: "NVDA",
    company: "NVIDIA Corp",
    insider: "Director / Officer",
    title: "Executive Leadership",
    transactionType: "Buy",
    shares: 1200,
    value: 1050000,
    date: "2026-05-15",
    signal: "Bullish",
  },
  {
    ticker: "NVDA",
    company: "NVIDIA Corp",
    insider: "Board Member",
    title: "Director",
    transactionType: "Hold / Ownership",
    shares: 8500,
    value: 7450000,
    date: "2026-05-10",
    signal: "Neutral",
  },
  {
    ticker: "MSFT",
    company: "Microsoft Corp",
    insider: "Executive",
    title: "Senior Officer",
    transactionType: "Sell",
    shares: 2000,
    value: 840000,
    date: "2026-05-08",
    signal: "Neutral",
  },
  {
    ticker: "PLTR",
    company: "Palantir Technologies",
    insider: "Executive",
    title: "Officer",
    transactionType: "Buy",
    shares: 5000,
    value: 1100000,
    date: "2026-05-04",
    signal: "Bullish",
  },
  {
    ticker: "TSLA",
    company: "Tesla Inc",
    insider: "Director",
    title: "Board Member",
    transactionType: "Sell",
    shares: 3500,
    value: 620000,
    date: "2026-04-30",
    signal: "Bearish",
  },
  {
    ticker: "AMZN",
    company: "Amazon.com Inc",
    insider: "Executive",
    title: "Senior Officer",
    transactionType: "Buy",
    shares: 900,
    value: 165000,
    date: "2026-04-27",
    signal: "Bullish",
  },
];

export default smartMoneyTransactions;